export default [
  '🏘️',
  '🏚️',
  '🏡',
  '🏢',
  '🏣',
  '🏤',
  '🏥',
  '🏪',
  '🏭',
  '⛲',
  '🎡',
  '🎪',
  '⛽',
  '🚧',
  '👪',
  '🙍',
  '👼',
  '👍',
  '💪',
];
